import {clearString, FullAlphabet, EngAlphabet, rotateAlphabet} from "./helpers/stringHelpers";

const SEPARATOR = ''
export const methods = {
    cypher: function (input, hasCh = false, missing = [], params, sep = SEPARATOR) {
        let cyphered = []
        let cleared = clearString(input, hasCh)//.replaceAll(/[ ]/g,'')
        missing.forEach((char) => {
            if (char !== 'ch')
                cleared = cleared.replaceAll(char, '')
        })
        let characters = cleared.split('');//.forEach((char)=>{ });
        let fakeMessage = (params[2]||'').toString();
        let skip = parseInt(params[1]) || 1;
        while ((fakeMessage.length) < (characters.length)) {
            fakeMessage += Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 1);
        }
        for (let i = 0; i < characters.length; i++) {
            let char = characters[i];
            cyphered.push(char);
            for (let rep = 0; rep < skip; rep++) {
                if (rep == 0) {
                    cyphered.push(fakeMessage[i]);
                } else {
                    cyphered.push(Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 1));
                }
            }

        }

        return cyphered.join(sep)
            .replaceAll('*', 'ch')
    },
    decypher: function (input, hasCh = false, missing = [], params) {
        let deciphered = []
        let cleared = clearString(input, hasCh)
        // let characters = input.replaceAll(/ {2}/g,' ').split(SEPARATOR);//.forEach((char)=>{ });
        let characters = cleared.split('');//.forEach((char)=>{ });
        let skip = parseInt(params[1]) || 1;
        for (let i = 0; i < characters.length; i=i+1+skip) {
            let char = characters[i];
            deciphered.push(char);
        }
        return deciphered.join('').replaceAll('*', 'ch')
    },
};

export default {...methods,SEPARATOR}